/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import { environment } from '../../environments/environment';
const secretKey = 'AEPL_ATCU_Diagnostics_Cloud';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  //login api
  userLogin(Payload): Observable<any> {
    return this.http.post(this.APIService + 'users/login', Payload);
  }

  forgotPassword(userEmail): Observable<any> {
    return this.http.get(
      this.APIService + 'users/forgetPassword?userEmail=' + userEmail
    );
  }

  generateExcelFile(serverData, firmwareData, fileName): void {
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();

    if (serverData.length > 0) {
      const headers = Object.keys(serverData[0]);
      const rows = serverData.map((item) => Object.values(item));
      const sheetData = [headers, ...rows];

      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Summary');
    }

    firmwareData.map((data) => {
      const outputdata = data.firmware.map((firm, index) => {
        return {
          'Sr. NO': index + 1,
          'Firmware Name': firm.firmwareVersion,
          'Firmware File Name': firm.fileName,
          'Firmware Uploaded At': this.formatDateTime(firm.releaseDate),
        };
      });

      if (outputdata.length > 0) {
        const headers = Object.keys(outputdata[0]);
        const rows = outputdata.map((item) => Object.values(item));
        const sheetData = [headers, ...rows];

        const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
      }
    });

    // Generate the Excel file and save it
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, 'Government_Servers_Report');
    this.openSnackbar('Report Generate SuccessFully');
  }

  createCSVFile(data, fileName) {
    if (data.length > 0) {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ['data'],
      };

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, fileName + '_' + new Date().getTime());
    } else {
      this.openSnackbar('No Data Found');
    }
  }

  private saveAsExcelFile(buffer, fileName): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    FileSaver.saveAs(data, fileName + '.xlsx');
  }

  exportToCsv(data, filename) {
    try {
      const csvContent = this.convertToCsv(data);
      const blob = new Blob([csvContent], { type: 'text/csv' });
      saveAs(blob, filename);
      this.spinner.hide();
    } catch (error) {
      console.error('exportToCsv error :>> ', error);
      this.spinner.hide();
    }
  }

  convertToCsv(data) {
    try {
      const header = Object.keys(data[0]).join(',');
      const rows = data.map((row) => Object.values(row).join(','));
      return [header, ...rows].join('\n');
    } catch (error) {
      console.error('convertToCsv error :>> ', error);
      this.spinner.hide();
      return '';
    }
  }

  formatDateTime(timestamp) {
    const dateObj = new Date(timestamp);
    const formattedDate = this.formatDate(dateObj);
    // const formattedTime = this.formatTime(dateObj);
    // return `${formattedDate} | ${formattedTime}`;
    return `${formattedDate}`;
  }

  formatDate(date: Date) {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    // return `${day}/${month}/${year}`;
    return `${day}-${month}-${year}`;
  }

  formatTime(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  back() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = event.url;
      });

    this.location.back();
  }

  openSnackbar(message) {
    return this.snackBar.open(message, 'close', {
      verticalPosition: 'bottom',
      horizontalPosition: 'right',
      duration: 4000,
      panelClass: ['snackbarStyle'],
    });
  }

  encryptData(message) {
    if (message) {
      return CryptoJS.AES.encrypt(
        JSON.stringify(message),
        secretKey
      ).toString();
    } else {
      return '';
    }
  }

  decryptData(message) {
    if (message) {
      const bytes = CryptoJS.AES.decrypt(message, secretKey);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
    return '';
  }

  redirect(destination) {
    this.router.navigate([destination]);
  }
}
